<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-info-card">
    <v-row class="com-pc-card-header">
      <div class="com-pc-card-title">{{ text.obsInfo }}</div>
      <v-tooltip bottom max-width="350px">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2"
            >help_outline</v-icon
          >
        </template>
        <span>
          <span>
            {{ legendStr.swStg.swStgMsg1 }}
            <br />
            {{ legendStr.swStg.swStgMsg2 }}
            <br />
          </span>
          <v-row no-gutters class="pt-1 pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-flood legend-swstg-item">
                  {{ legendStr.swStg.flood1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-flood legend-swstg-detail">
                  {{ legendStr.swStg.flood2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-danger legend-swstg-item">
                  {{ legendStr.swStg.danger1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-danger legend-swstg-detail">
                  {{ legendStr.swStg.danger2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-start legend-swstg-item">
                  {{ legendStr.swStg.start1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-start legend-swstg-detail">
                  {{ legendStr.swStg.start2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
        </span>
      </v-tooltip>
      <div class="tm-pc-info-card-info-area">
        <v-tooltip left v-if="!pcPanelMode">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              small
              @click="changePanelMode(true)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOn }}</span>
        </v-tooltip>
        <v-tooltip left v-if="pcPanelMode">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              small
              @click="changePanelMode(false)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOff }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark small @click="openObs()" v-bind="attrs" v-on="on">
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.detailView }}</span>
        </v-tooltip>
      </div>
    </v-row>
    <v-row class="com-pc-card-contents" no-gutters>
      <v-expansion-panels accordion light class="tm-pc-obs-panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="tm-pc-obs-panel-header" expand-icon="arrow_drop_down">
            <v-row class="tm-pc-info-card-info">
              <v-col class="tm-pc-info-card-name-area">
                <v-row no-gutters>
                  <div>
                    <div class="tm-pc-info-card-name-kana">
                      {{ tmSwStageMtObs.swobsNmKana }}
                    </div>
                    <div class="tm-pc-info-card-name">
                      {{ tmSwStageMtObs.swobsNm }}
                    </div>
                  </div>
                  <div class="pl-2">
                    <div class="tm-pc-info-card-name-kana"><span v-if="tmSwStageMtObs.swrsysKana">{{ tmSwStageMtObs.swrsysKana }}{{ text.rsysKana }}</span></div>
                    <div class="tm-pc-info-card-name">
                      {{ tmSwStageMtObs.swrsysNm }}{{ text.rsys }}
                    </div>
                  </div>
                  <div class="pl-2">
                    <div class="tm-pc-info-card-name-kana">{{ tmSwStageMtObs.swrvrKana }}</div>
                    <div class="tm-pc-info-card-name">
                      {{ tmSwStageMtObs.swrvrNm }}
                    </div>
                  </div>
                </v-row>
                <v-row no-gutters v-show="!pcPanelMode">
                  <div class="tm-pc-curt-time">
                    {{ text.obsTime }} {{ obsTime }}
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <!-- 観測所情報 -->
              <v-list-item
                v-for="(item, index) in tmSwobsInfo"
                :key="`obs-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content
                  v-if="item.itmkndCd"
                  class="tm-pc-link"
                  @click="clickObsList(item.ofcCd, item.itmkndCd, item.obsCd)"
                  >{{ item.value }}</v-list-item-content
                >
                <v-list-item-content v-else>
                  <div style="line-break: strict">
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                    <span class="list-value">{{ item.code }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- 基準値 -->
              <v-list-item
                v-for="(item, index) in standardValue"
                :key="`sd-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content>
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- コード値 -->
              <v-list-item
                v-for="(item, index) in codeInfo"
                :key="`cd-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content>
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]危機管理 観測所情報カード
 * TmSwStageInfo.vue
 * @author ILUKE
 */
import Util from "./../../lib/util.js";
import mixin from "./../../lib/mixin.js";

export default {
  name: "tm-sw-stage-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        obsTime: "最新観測値",
        obsInfo: "観測所情報",
        obsType: "水位計",
        rsys: "水系",
        rsysKana: "すいけい",
      },
    };
  },
  mounted() {},
  computed: {
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return this.$store.state.Swin.selectedSwParam;
      },
    },
    /**
     * 危機管理マスタ情報 取得
     */
    tmSwStageMtObs: {
      get() {
        return this.$store.state.Swin.selectedSw.mtSwobs.obsInfo;
      },
    },
    /**
     * 危機管理観測所情報 取得
     */
    tmSwobsInfo: {
      get() {
        return this.$store.state.Swin.selectedSw.obsInfo;
      },
    },
    /**
     * 基準値 取得
     */
    standardValue: {
      get() {
        return this.$store.state.Swin.selectedSw.standardValue;
      },
    },
    /**
     * コード値 取得
     */
    codeInfo: {
      get() {
        return this.$store.state.Swin.selectedSw.codeValue;
      },
    },
    /**
     * 観測時間 取得
     */
    obsTime: {
      get() {
        return this.$store.state.Swin.selectedSw.curt.obsTime;
      },
    },
    /** フレームの拡大・縮小判定用 */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
  },
  methods: {
    /** 詳細画面遷移 */
    openObs() {
      if (!this.$store.state.app.isCurrent) {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            itmkndCd: this.$store.state.Swin.selectedSwParam.itmkndCd,
            ofcCd: this.$store.state.Swin.selectedSwParam.swofcCd,
            obsCd: this.$store.state.Swin.selectedSwParam.swobsCd,
            appTime: Util.formatDate(
              this.$store.state.app.appTime,
              "YYYY-MM-DD HH:mm"
            ),
            appTimeRound: Util.formatDate(
              this.$store.state.app.appTimeRound,
              "YYYY-MM-DD HH:mm"
            ),
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_blank", "noreferrer,noopener");
      } else {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            itmkndCd: this.$store.state.Swin.selectedSwParam.itmkndCd,
            ofcCd: this.$store.state.Swin.selectedSwParam.swofcCd,
            obsCd: this.$store.state.Swin.selectedSwParam.swobsCd,
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_blank", "noreferrer,noopener");
      }
    },
    /** 観測所リンク */
    clickObsList(ofcCd, itmkndCd, obsCd) {
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: ofcCd,
        itmkndCd: itmkndCd,
        obsCd: obsCd,
      });
      // 画面遷移
      this.routerPushTm("/pc/tm");
    },
    /** フレームの拡大縮小*/
    changePanelMode(bln) {
      this.$log.debug("[TmSw] changePanelMode(" + bln + ")");
      if (bln) {
        this.replacePanelMode("1");
        this.$store.commit("app/setPcPanelModeContent", "tmObs");
      } else {
        this.replacePanelMode("0");
        this.$store.commit("app/setPcPanelModeContent", null);
      }
      this.$store.commit("app/setPcPanelMode", bln);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
